module.exports = __webpack_public_path__ + "static/media/health-care.6b05d54b.jpg";